import { render, staticRenderFns } from "./onboarding-features-outro-block.vue?vue&type=template&id=5e9b8b86&scoped=true&lang=pug"
import script from "./onboarding-features-outro-block.vue?vue&type=script&lang=js"
export * from "./onboarding-features-outro-block.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e9b8b86",
  null
  
)

export default component.exports